module.exports = __webpack_public_path__ + "static/img/business-child.40e1361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/business-child.jpg
// module id = Ztc0
// module chunks = 1